import { CustomPhotosItem } from "./file.type";

export enum EAlbumStatus {
	PUBLISH = "PUBLISH",
	UNPUBLISH = "UNPUBLISH",
}
export enum EAlbumItemType {
	PHOTO = "PHOTO",
	VIDEO = "VIDEO",
}
export interface AlbumItem {
	type: EAlbumItemType;
	file?: CustomPhotosItem;
	youtubeUrl?: string;
	videoThumbnail?: CustomPhotosItem;
}
export interface AlbumProperties {
	albumId: string;
	title: string;
	description?: string;
	mainImageUrl?: string;
	items: AlbumItem[];
	status: EAlbumStatus;
	createdByUserId: string;
	createdByUserMeta: any;
	updatedAt?: Date;
	createdAt?: Date;
}
export interface FindAllAlbumQuery {
	filterStatus?: string;
}
